<template>
  <div class="personlist">
    <div class="person-box">
      <div class="items-box" v-for="(items,idx) in contacts" :key="idx">
        <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
        <div class="info-box">
          <div class="username">{{items.name}}</div>
          <div class="phone">{{items.mobile}}</div>
        </div>
          <div class="phone-box" @click="sendMessage(items)">
              <van-icon name="chat" color="#36b374" size="15" :dot="!!items.unreadCount" />
          </div>
        <div class="phone-box" @click="playPhone(items)">
          <div class="times"  v-if="items.timer">{{items.timer}}</div>
          <a><img src="../../assets/index/ic_ts_dh.png" alt class="phone-icon" /></a>
        </div>
      </div>
    </div>
     <empty :type="3" v-if="contacts.length === 0"></empty>
     <callPhone ref="callPhone" :combinPhone="combinPhone" :userInfo="userInfo"></callPhone>
  </div>
</template>

<script>
    import mixin from '@/mixins/index';
    import api from 'apis'
    import callPhone from 'comps/callPhone';
    import empty from 'comps/empty';
    import {
        mapState
    } from 'vuex';
    export default {
        mixins: [mixin],
        components: { callPhone, empty },
        data () {
            return {
                isTimeShow: false,
                list: [],
                combinPhone: 0,
	            userInfo: {}

            };
        },
        computed: {
            contacts () {
                return this.$store.getters['home/contactsList']
            },
	        currentUserInfo () {
		        return this.$store.state.home['currentUserInfo']
	        }
        },
        watch: {},
        methods: {
            playPhone (item) {
                this.call(item)
                this.combinPhone = Number(item.mobile);
	            this.userInfo = {
		            targetName: item.name,
		            targetId: item.staffCode,
		            userId: this.currentUserInfo.staffCode,
		            name: this.currentUserInfo.name
	            };
                this.$refs.callPhone.showBox();
            },
	        async sendMessage(item) {
		        if (this.currentUserInfo.name) {
			        await api.importAccount({
				        nick: this.currentUserInfo.name,
				        identifier: `yjg_${this.currentUserInfo.staffCode}`
			        });
		        }
		        if (item.name) {
			        await api.importAccount({
				        nick: item.name,
				        identifier: `yjg_${item.staffCode}`
			        });
		        }
		        let value = {
			        targetId: item.staffCode,
			        userId: this.currentUserInfo.staffCode
		        };
		        let str = [];
		        for (let key in value) {
			        str.push(key + '=' + value[key]);
		        }
		        let query = str.join('&');
		        if (process.env.NODE_ENV === 'development') {
			        this.$router.push({
				        path: `/personalChat?${query}`
			        })
		        }
		        window.yyn.invokeJSB(
			        'openWindow',
			        {
				        openUrl: `${this.globalApp.getSystemInfo().host}web/#/personalChat?${query}`,
				        isFullScreen: 1,
				        setTitle: '',
				        needLoading: 1
			        },
			        cb => {
				        console.log(cb, 'callback');
			        }
		        );
	        }
        },
        mounted () {
            this.$store.dispatch('home/loadContacts')
        },

        created () {}
    };
</script>

<style scoped lang="less">
.personlist {
  width: 100%;

  .back-box {
    height: 44px;
    position: relative;
    box-sizing: border-box;
    padding: 0 12px;
    background: #36b374;

    .text {
      font-size: 16px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
    }
    .back-icon {
      width: 10px;
      height: 16px;
      position: absolute;
      left: 20px;
      top: 14px;
    }
  }

  .person-box {
    box-sizing: border-box;
    padding: 0 12px 16px 12px;

    .items-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      height: 68px;
      box-sizing: border-box;
      padding: 16px 0;
      border-bottom: 1px solid #eeeeee;

      &:last-child {
        border-bottom: none;
      }

      .headimg {
        width: 36px;
        height: 36px;
        margin-right: 12px;
      }

      .info-box {
        flex: 1;
        text-align: left;
        .username {
          height: 20px;
          font-size: 16px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          // line-height: 16px;
          line-height: 20px;
          margin-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 200px;
        }
        .phone {
          height: 12px;
          font-size: 12px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }
      .phone-box {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-right: 8px;

        .times {
          height: 12px;
          font-size: 12px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
          margin-right: 12px;
        }
        .phone-icon {
          width: 14px;
          height: 16px;
        }
      }
    }
  }
}
</style>
